import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { Focusable, FocusableParent } from 'components/navigation';

export const StyledButtonsWrapper = styled(FocusableParent)`
  width: ${scaleSize(1480)}px;
  height: ${scaleSize(140)}px;
  margin-left: ${scaleSize(220)}px;
  text-align: left;
  position: relative;
`;

export const StyledProgramPopup = styled.div`
  display: none;
  position: absolute;
  width: ${scaleSize(740)}px;
  text-align: center;
  margin-top: ${scaleSize(10)}px;
  font-size: ${scaleSize(32)}px;
`;

export const StyledPrevProgramPopup = styled(StyledProgramPopup)`
  left: ${scaleSize(-310)}px;
`;

export const StyledNextProgramPopup = styled(StyledProgramPopup)`
  right: ${scaleSize(-310)}px;
`;

export const StyledControlButton = styled(Focusable)`
  width: ${scaleSize(120)}px;
  height: ${scaleSize(120)}px;
  background-color: transparent;
  display: ${({ isHidden }) => (!isHidden ? 'inline-block' : 'none')};
  border-radius: 50%;
  text-align: center;
  color: #ffffff;
  vertical-align: top;
  box-sizing: border-box;
  opacity: ${({ isNotAvailable }) => (isNotAvailable ? 0.5 : 1)};

  & > svg {
    width: ${scaleSize(120)}px;
    height: ${scaleSize(120)}px;
  }

  &:focus {
    background-color: ${({ theme }) => theme.playerButtonBg};
  }
`;

export const StyledEPGButton = styled(StyledControlButton)`
  width: ${scaleSize(120)}px;
  height: ${scaleSize(120)}px;
  position: absolute;
  left: ${scaleSize(680)}px;

  &:focus ${StyledProgramPopup} {
    display: block;
    position: relative;
    width: ${scaleSize(300)}px;
    left: -${scaleSize(85)}px;
    top: ${scaleSize(10)}px;
    font-size: ${scaleSize(32)}px;
    margin-top: 0;
  }

  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledOnAirButton = styled(StyledControlButton)`
  position: absolute;
  left: ${scaleSize(205)}px;
  width: auto;
  height: ${scaleSize(62)}px;
  line-height: ${scaleSize(34)}px;
  font-size: ${scaleSize(24)}px;
  padding: ${scaleSize(15)}px ${scaleSize(20)}px;
  background-color: ${({ theme }) => theme.playerButtonBg};
  border-radius: ${scaleSize(32)}px;
  margin-top: ${scaleSize(30)}px;

  & > svg {
    width: ${scaleSize(20)}px;
    height: ${scaleSize(20)}px;
    margin-right: ${scaleSize(15)}px;
  }

  &:focus {
    color: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledPlayButton = styled(StyledControlButton)`
  position: absolute;
  left: ${scaleSize(1020)}px;

  &.movie {
    left: ${scaleSize(680)}px;
  }

  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledRewindButton = styled(StyledControlButton)`
  padding: ${scaleSize(38)}px 0 0 0;

  & > svg {
    margin-left: -${scaleSize(8)}px;
  }

  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledFFButton = styled(StyledControlButton)`
  padding: ${scaleSize(38)}px 0 0 ${scaleSize(10)}px;

  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledPrevButton = styled(StyledControlButton)`
  position: absolute;
  left: ${scaleSize(520)}px;

  &:focus ${StyledPrevProgramPopup} {
    display: block;
  }
  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledNextButton = styled(StyledControlButton)`
  position: absolute;
  left: ${scaleSize(840)}px;

  &:focus ${StyledNextProgramPopup} {
    display: block;
  }
  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledSettingsButton = styled(StyledControlButton)`
  position: absolute;
  right: 0;

  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledWatchlistButton = styled(StyledControlButton)`
  position: absolute;
  display: ${({ isHidden }) => (!isHidden ? 'inline-block' : 'none')};
  right: ${scaleSize(160)}px;

  & > svg {
    & > path {
      fill: ${({ theme, isActive }) => (isActive ? theme.activeColor : theme.defaultColor)};
      stroke: ${({ theme, isActive }) => (isActive ? theme.activeColor : theme.defaultColor)};
    }
  }

  &:focus > svg > path {
    fill: ${({ theme }) => theme.activeColor};
    stroke: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledFavoriteActionPanel = styled.div`
  width: ${scaleSize(1508)}px;
  vertical-align: top;
`;

export const StyledFavoritePanelConfirmButton = styled(Focusable)`
  display: inline-block;
  vertical-align: top;
  width: ${scaleSize(614)}px;
  height: ${scaleSize(120)}px;
  line-height: ${scaleSize(120)}px;
  font-size: 34px;
  border-radius: ${scaleSize(60)}px;
  color: ${({ theme }) => theme.defaultColor};

  &:focus {
    background-color: ${({ theme }) => theme.playerButtonBg};
    color: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledFavoriteButtonText = styled.div`
  font-family: RobotoRegular;
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(34)}px;
  letter-spacing: -0.24px;
  text-align: center;
`;

export const StyledCancelPopup = styled.div`
  display: none;
  position: absolute;
  text-align: center;
  margin-top: ${scaleSize(-40)}px;
  font-size: ${scaleSize(32)}px;
  line-height: ${scaleSize(48)}px;
`;

export const StyledFavoritePanelCancelButton = styled(Focusable)`
  display: inline-block;
  vertical-align: top;
  width: ${scaleSize(120)}px;
  height: ${scaleSize(120)}px;
  line-height: ${scaleSize(120)}px;
  margin: 0 ${scaleSize(80)}px;
  border-radius: 50%;
  color: ${({ theme }) => theme.defaultColor};

  &:focus ${StyledCancelPopup} {
    display: block;
  }

  &:focus {
    background-color: ${({ theme }) => theme.playerButtonBg};
  }

  &:focus > svg > path {
    stroke: ${({ theme }) => theme.activeColor};
  }
`;
